class ScrollingFeaturesBar {
  constructor() {
    this.hoverTracks = new WeakSet();
    this.frame = null;
    this.schedule = () => {
      if (this.frame !== null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.setup();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.schedule, { once: true });
    } else {
      this.schedule();
    }
    window.addEventListener('resize', this.schedule, { passive: true });
    document.addEventListener('shopify:section:load', this.schedule);
    if (document.fonts) document.fonts.ready.then(this.schedule);
  }

  setup() {
    // Measure each actual track once, before any layout writes.
    const measurements = Array.from(document.querySelectorAll('.features-track')).map((track) => {
      const container = track.closest('.features-track-container');
      const items = track.querySelector('.feature-items');
      if (!container || !items) return null;
      if (track.closest('.pause-on-hover') && !this.hoverTracks.has(track)) {
        track.addEventListener('mouseenter', () => { track.style.animationPlayState = 'paused'; });
        track.addEventListener('mouseleave', () => { track.style.animationPlayState = 'running'; });
        this.hoverTracks.add(track);
      }
      return { track, container, width: items.offsetWidth * 6, height: items.offsetHeight };
    }).filter(Boolean);
    measurements.forEach(({ track, container, width, height }) => {
      if (width > 0 && track.style.width !== `${width}px`) track.style.width = `${width}px`;
      if (container.style.height !== `${height}px`) container.style.height = `${height}px`;
    });
  }
}
new ScrollingFeaturesBar();
